import Vue from 'vue'
import Router from 'vue-router'
import i18n from './plugins/i18n/i18n'
import goTo from 'vuetify/es5/services/goto'
import { store } from './store'
import { userVar } from '@/js/auth/userVar'

Vue.use(Router)


// const ifNotAuthenticated = async (to, from, next) => {
//   const isAuth = await store.getters['auth/isAuthenticated']
//   console.log(isAuth)
//   if (!isAuth) {
//     i18n.locale = (i18n.locale == 'en-EN') || (i18n.locale == 'en') ? 'en' :
//                   (i18n.locale == 'fr-FR') || (i18n.locale == 'fr') ? 'fr' :
//                   (i18n.locale == 'nl-NL') || (i18n.locale == 'nl') ? 'nl' : 'fr'
//     next()

//   } else if (isAuth) {
//     next('/dashboard')

//   } else {
//     next('/')
//   }
// }

// const ifNotAuthenticated = (to, from, next) => {
//   console.log('ONCE')
//   next()
// }

const ifAuthenticated = async (to, from, next) => {
  try {
    var isAuth = await store.getters['auth/isAuthenticated']
    if (isAuth) {
      await userVar({
        options: 'get',
        name: 'lang',
        key: store.state.auth.token
      }).then(response => {
        if (response.data !== '') {
          i18n.locale = response.data
          next()
        }
        else {
          i18n.locale = (i18n.locale == 'en-EN') || (i18n.locale == 'en') ? 'en' :
                        (i18n.locale == 'fr-FR') || (i18n.locale == 'fr') ? 'fr' :
                        (i18n.locale == 'nl-NL') || (i18n.locale == 'nl') ? 'nl' : 'fr'
          next()
        }
      })
      .catch(() => { next('/') })
    }
  } catch {
    next('/')
  }

  // const isAuth = await store.getters['auth/isAuthenticated']
  // if (isAuth) {
  //   userVar({
  //     options: 'get',
  //     name: 'lang',
  //     key: store.state.auth.token
  //   }).then(response => {
  //     if (response.data !== '') {
  //       i18n.locale = response.data
  //       next()
  //     }
  //     else {
  //       i18n.locale = (i18n.locale == 'en-EN') || (i18n.locale == 'en') ? 'en' :
  //                     (i18n.locale == 'fr-FR') || (i18n.locale == 'fr') ? 'fr' :
  //                     (i18n.locale == 'nl-NL') || (i18n.locale == 'nl') ? 'nl' : 'fr'
  //       next()
  //     }
  //   })
  //   .catch(() => { next('/') })

  //   next()

  // } else {
  //   next('/')
  // }
}

export default new Router({
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { // 404
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */ './views/404.vue')
    },
    {
      path: '/',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/auth/Login.vue'),
      // beforeEnter: ifNotAuthenticated
    },
    // {
    //   path: '/help',
    //   name: 'help',
    //   component: () => import(/* webpackChunkName: "help" */ './views/Help.vue')
    // },

    // Auth screen
    {
      path: '/signup',
      name: 'signup',
      component: () => import(/* webpackChunkName: "signup" */ './views/auth/Signup.vue'),
      // beforeEnter: ifNotAuthenticated
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: () => import(/* webpackChunkName: "thankyou" */ './views/auth/Thankyou.vue'),
      // beforeEnter: ifNotAuthenticated
    },
    {
      path: '/signup-confirm/:login&:key',
      name: 'signup-confirm',
      component: () => import(/* webpackChunkName: "signup-confirm" */ './views/auth/SignupConfirm.vue'),
      // beforeEnter: ifNotAuthenticated
    },
    {
      path: '/lostpassword',
      name: 'lostpassword',
      component: () => import(/* webpackChunkName: "lostpassword" */ './views/auth/LostPassword.vue'),
      // beforeEnter: ifNotAuthenticated
    },

    // Onboarding
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import(/* webpackChunkName: "welcome" */ './views/onboarding/Welcome.vue'),
      beforeEnter: ifAuthenticated
    },

    // User profile screen
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './views/profile/Profile.vue'),
      beforeEnter: ifAuthenticated
    },

    // Interface screen
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ './views/interface/Dashboard.vue'),
      // return () => import(/* webpackChunkName: "dashboard-inspector" */ './views/interface/DashboardInspector.vue')
      beforeEnter: ifAuthenticated
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "faq" */ './views/interface/Faqs.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/questions',
      name: 'questions',
      component: () => import(/* webpackChunkName: "questions" */ './views/interface/Questions.vue'),
      beforeEnter: ifAuthenticated
    },

    // Audit
    // ...
    {
      path: '/create-audit/',
      name: 'create-audit',
      component: () => import(/* webpackChunkName: "create-audit" */ './views/audits/CreateAudit.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/edit-audit/:firmid&:answerid&:sequenceid',
      name: 'edit-audit',
      component: () => import(/* webpackChunkName: "edit-audit" */ './views/audits/EditAudit.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/edit-audit-unanswered/:firmid&:answerid&:sequenceid&:questionid',
      name: 'edit-audit-unanswered',
      component: () => import(/* webpackChunkName: "edit-audit-unanswered" */ './views/audits/EditAuditUnanswered.vue'),
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/final-report/:firmid&:answerid&:sequenceid',
    //   name: 'final-report',
    //   component: () => import(/* webpackChunkName: "final-report" */ './views/audits/FinalReport.vue'),
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/certificate-request',
      name: 'certificate-request',
      component: () => import(/* webpackChunkName: "certificate-request" */ './views/audits/CertificateRequest.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/validate-audit/:validkey&:answerid&:sequenceid',
      name: 'validate-audit',
      component: () => import(/* webpackChunkName: "validate-audit" */ './views/audits/ValidateAudit.vue'),
      // beforeEnter: ifNotAuthenticated
    },

    // Delegate
    {
      path: '/task/:answerid&:collaboratorid&:key',
      name: 'task',
      component: () => import(/* webpackChunkName: "task" */ './views/audits/DelegatedAudit.vue')
    }
  ]
})
